import { render, staticRenderFns } from "./AccountMovementsTable.vue?vue&type=template&id=9a3a89f2&scoped=true&"
import script from "./AccountMovementsTable.vue?vue&type=script&lang=js&"
export * from "./AccountMovementsTable.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/table.css?vue&type=style&index=0&id=9a3a89f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a3a89f2",
  null
  
)

export default component.exports